import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getShopifyApps,
    updateShopifyApp
}

function getShopifyApps(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/shopify/app`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateShopifyApp(shopifyId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/shopify/app/${shopifyId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}